import styled, { css } from 'styled-components'

import { Button } from '@sketch/components'

export const Action = styled(Button)`
  ${({ variant }) =>
    variant === 'secondary-untinted' &&
    css`
      && > * {
        opacity: 0.55;
      }
    `}
  & [role='img'] {
    width: 16px;
  }

  padding: 6px 8px; /* stylelint-disable-line scales/space */
`
